import { sort } from 'fast-sort'
import { headerHeight } from './styles'
import useLexicon from '../../../hooks/useLexicon'

// https://stackoverflow.com/a/56391657
export const scrollElementIntoView = element => {
  const yOffset = -100
  const y =
    element.getBoundingClientRect().top +
    window.pageYOffset +
    yOffset -
    headerHeight
  setImmediate(
    () => window.scrollTo({ top: y, behavior: 'smooth' })
  )
}

export const scrollIntoView = id => {
  const element = document.getElementById(id)
  if (element) {
    scrollElementIntoView(element)
  }
}

export const getActiveActivityIndex = (compiledQuest, userCompiledQuest) => {
  const t = compiledQuest.document.activities.map((activity, index) => ({
    index,
    id: activity.id
  }))
  const x = t.filter(a =>
    userCompiledQuest.user_quest_activities.find(ac => ac.activity_id === a.id)
  )
  return Math.max(...x.map(v => v.index))
}

export const getParam = (params, name) =>
  params && params[name] ? parseInt(params[name]) : null

export const getStudentsSortedByName = students =>
  sort(students).by([{ asc: student => student.name }])

export const getStudentsSortedByFeedbackAndName = students =>
  sort(students).by([
    {
      desc: ({ quest_progress }) =>
        +quest_progress.awaiting_feedback +
        +quest_progress.awaiting_artifact_assessment
    },
    { asc: student => student.name }
  ])

export const getStudentSkillsChecks = (uqcSkillsChecks, activityId) =>
  uqcSkillsChecks.data
    ? uqcSkillsChecks.data.filter(
      sc => sc.activity_id === activityId && sc.self_assessment
    )
    : []

export const isQuestLocked = (
  userHasStartedQuest,
  userCompiledQuests,
  maxActiveQuests,
  currentUserLevel,
  levelId,
  lexicon
) => {
  let val
  let reason = ''
  const activeQuestsCount = userCompiledQuests.filter(uq => !uq.completed_at)
    .length

  if (userHasStartedQuest) {
    val = false
  } else if (activeQuestsCount >= maxActiveQuests) {
    val = true
    reason = `Complete one of your active ${lexicon.quest.toLowerCase()}s to begin this ${lexicon.quest.toLowerCase()}.`
  } else {
    // if user is in a course, check level stuff, otherwise don't lock it down
    // levelId is only there when navigating from level detail
    val = levelId && currentUserLevel ? currentUserLevel.locked : true
    reason = 'Complete required levels to begin this quest.'
  }

  return {
    val,
    reason
  }
}
